// import {
//   BrandPayload,
//   BrandSubmitForm,
//   Brands,
//   UpdateBrandStatus,
// } from "models/brand";
// import { BrandLocationPayload, BrandLocations, BrandList } from "models/brandLocation";
import { BrandList, StoreList, DocumentForm } from "models/document";
import axiosClient from "./axiosClient";
import { ApiResponse, RemovePayload, DocumentUrlData } from "models";
// import { ApiResponse, RemovePayload } from "models";

const documentApi = {
  getCustomerList(): Promise<any> {
    const url = "/customer/getAllCustomer?disablePagination=true";
    return axiosClient.get(url);
  },

  getDocumentList(data: any): Promise<any> {
    const url = `/documentManage/getDocument?limit=${data.limit || ""}&page=${
      data.page || ""
    }&region=${data.region || ""}&search=${data.search || ""}&sortField=${
      data.sortName || ""
    }&sortType=${data.sortType || ""}`;
    return axiosClient.get(url);
  },

  getDocumentById(data: any): Promise<any> {
    const url = `/documentManage/getDocument?_id=${
      data.id || ""
    }&disablePagination=true`;
    return axiosClient.get(url);
  },

  addDocument(data: any): Promise<ApiResponse> {
    const url = `/documentManage/addDocument`;
    return axiosClient.post(url, data, {
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    });
  },

  updateDocument(data: DocumentForm): Promise<ApiResponse> {
    const url = `/documentManage/updateDocument`;
    return axiosClient.put(url, data);
  },

  deleteDocument(data: RemovePayload): Promise<ApiResponse> {
    const url = `/documentManage/removeDocument?id=${data._id}`;
    return axiosClient.post(url);
  },

  // getImageUrl(data: ImageUrlData): Promise<ApiResponse> {
  //   const url = `/settings/uploadImage`;
  //   return axiosClient.post(url, data, {
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //     },
  //   });
  // },

  brandListApi(data: BrandList): Promise<ApiResponse> {
    const url = `/brand/getBrandByCustomerId?customerId=${data.customerId}`;
    return axiosClient.get(url, {});
  },

  storeListApi(data: StoreList): Promise<ApiResponse> {
    const url = `/store/getStoreByBrandId?brandId=${data.brandId}`;
    return axiosClient.get(url, {});
  },

  getDocumentUrl(data: DocumentUrlData): Promise<ApiResponse> {
    const url = `/settings/uploadImage`;
    return axiosClient.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default documentApi;
